import { literal, string, struct } from 'io-ts/lib/Decoder';

import { Segment } from '../frame/Segment';

/**
 * Sent when a segment is created and attached to a frame.
 * Server will recompute the frame geometry after creation.
 */
export const SegmentCreated = struct({
	type: literal('segment-created'),
	frameId: string,
	segment: Segment,
});
